import React from "react";
import Carousel from "react-bootstrap/Carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import "../style/Home.css";
import "../style/Footer.css";

library.add(faBriefcase, fab);

const Home = () => {
  const web = [
    {
      id: 1,
      title: "HBO GO",
      img: "https://www.hbogoasia.id/static/images/imgplaceholderLandscape414@3x.png",
      address: "https://www.hbo.com/",
    },
    {
      id: 2,
      title: "NETFLIX",
      img: "https://cdn.mos.cms.futurecdn.net/Yy247gYvzaMZXprhZHXy4E.jpg",
      address: "https://www.netflix.com/",
    },
    {
      id: 3,
      title: "HULU",
      img: "https://pics.paypal.com/00/c/gifts/us/hulu.jpg",
      address: "https://www.hulu.com/",
    },
  ];

  return (
    <>
      {/*Start of Carousel*/}
      {/*First, I created a Carousel which contains a list of three images including their website, to watch TV Shows and Movies.*/}
      <Carousel>
        {web.map((web) => {
          return (
            <Carousel.Item>
              <img className="d-block w-100" src={web.img} alt="First slide" />
              <Carousel.Caption>
                <h3>{web.title}</h3>
                <a href={web.address} target={"_blank"} rel="noreferrer">
                  {web.address}
                </a>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
      {/*End of Carousel*/}

      <div className="card-container">
        <div className="cards">
          <img
            className="img-card"
            src="https://moviesmarkus.files.wordpress.com/2022/06/top-gun.jpg"
            alt="Top Gun Maverick"
          />
          <h4>Top Gun Maverick</h4>
          <p>
            After thirty years, Maverick is still pushing the envelope as a top
            naval aviator, but must confront ghosts of his past when he leads
            TOP GUN's elite graduates on a mission..
          </p>
          <a
            href="https://www.imdb.com/title/tt1745960/"
            target="_blank"
            rel="noreferrer"
            aria-label="Take a look at Top Gun Maverick"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://www.thebatman.com/images/share.jpg"
            alt="The Batman"
          />
          <h4>The Batman</h4>
          <p>
            When a sadistic serial killer begins murdering key political figures
            in Gotham, Batman is forced to investigate the city's hidden
            corruption and question his family's involvement.
          </p>
          <a
            href="https://www.imdb.com/title/tt1877830/"
            target="_blank"
            rel="noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://ntvb.tmsimg.com/assets/p19738510_v_h8_ag.jpg?w=1280&h=720"
            alt="Black Adam"
          />
          <h4>Black Adam</h4>
          <p>
            Nearly 5,000 years after he was bestowed with the almighty powers of
            the Egyptian gods--and imprisoned just as quickly--Black Adam is
            freed from his earthly tomb,
          </p>
          <a
            href="https://www.imdb.com/title/tt6443346/"
            target="_blank"
            rel="noreferrer"
          >
            Learn More
          </a>
        </div>
      </div>

      <div className="card-container">
        <div className="cards">
          <img
            className="img-card"
            src="https://roost.nbcuni.com/bin/viewasset.html/content/dam/Peacock/Landing-Pages/2-0-design/bk99/brooklyn-99-social.jpg/_jcr_content/renditions/original.JPEG"
            alt="Brooklyn 99"
          />
          <h4>Brooklyn Nine-Nine</h4>
          <p>
            Comedy series following the exploits of Det. Jake Peralta and his
            diverse, lovable colleagues as they police the NYPD's 99th Precinct.
          </p>
          <a
            href="https://www.imdb.com/title/tt2467372/"
            target="_blank"
            rel="noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://assets-prd.ignimgs.com/2022/12/22/12908211-1671745643746.jpg"
            alt="The Last of Us"
          />
          <h4>The Last of Us</h4>
          <p>
            After a global pandemic destroys civilization, a hardened survivor
            takes charge of a 14-year-old girl who may be humanity's last hope.
          </p>
          <a
            href="https://www.imdb.com/title/tt3581920/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://upload.wikimedia.org/wikipedia/en/0/09/Community_title.jpg"
            alt="Community"
          />
          <h4>Community</h4>
          <p>
            A suspended lawyer is forced to enroll in a community college with
            an eccentric staff and student body.
          </p>
          <a
            href="https://www.imdb.com/title/tt1439629/?ref_=nv_sr_srsg_0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
      </div>

      <div className="card-container">
        <div className="cards">
          <img
            className="img-card"
            src="https://media.comicbook.com/2020/10/blood-of-zeus-netflix-anime-1242059.jpeg?auto=webp"
            alt="Blood Of Zeus"
          />
          <h4>Blood Of Zeus</h4>
          <p>
            A commoner living in ancient Greece, Heron discovers his true
            heritage as a son of Zeus, and his purpose: to save the world from a
            demonic army.
          </p>
          <a
            href="https://www.imdb.com/title/tt10009170/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://i.ytimg.com/vi/cYNGDUIBUhE/maxresdefault.jpg"
            alt="Castlevania"
          />
          <h4>Castlevania</h4>
          <p>
            A vampire hunter fights to save a besieged city from an army of
            otherworldly creatures controlled by Dracula.
          </p>
          <a
            href="https://www.imdb.com/title/tt6517102/?ref_=nv_sr_srsg_0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="cards">
          <img
            className="img-card"
            src="https://ic.c4assets.com/brands/rick-and-morty/25061866-e35b-405b-9cb4-cb71748e9592.jpg?interpolation=progressive-bicubic&output-format=jpeg&output-quality=90&resize=1160px:*"
            alt="Rick&Morty"
          />
          <h4>Rick&Morty</h4>
          <p>
            An animated series that follows the exploits of a super scientist
            and his not-so-bright grandson.
          </p>
          <a
            href="https://www.imdb.com/title/tt2861424/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </div>
      </div>

      <Accordion defaultActiveKey={["0"]} alwaysOpen className="accordion">
        <Accordion.Item>
          <Accordion.Header>Here is a list of websites:</Accordion.Header>
          <Accordion.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Must Paid Websites</th>
                  <th>Free Websites</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <a
                      href="https://www.netflix.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Netflix
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://himovies.top/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      HiMovies
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>
                    <a
                      href="https://www.hbo.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      HBO
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://www.putlocker.mom/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Putlocker
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>
                    <a
                      href="https://www.hulu.com/welcome?orig_referrer=https%3A%2F%2Fwww.google.com%2F"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      HULU
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://filma24.ch/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Filma24
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>
                    <a
                      href="https://tv.apple.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      AppleTV
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://moviewatcher.eu/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      MovieWatcher
                    </a>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {/*-----------Start of Footer----------- */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>&copy; 2023 Roland Ajeti. All Rights Reserved.</p>
            </div>
            <div className="col-md-6">
              <ul className="footer-links">
                <li>
                  <a href="home" className="anchor">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Contact Us
                  </a>
                </li>
              </ul>
              <ul className="social-icons">
                <li>
                  <a
                    href="https://www.instagram.com/rolandajeti/"
                    aria-label="Take a look at my Instagram Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/roland-ajeti-834335207/"
                    aria-label="Take a look at my LinkedIn Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "linkedin"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCA7Tj3B9h2FikEHcEJI4cnQ"
                    aria-label="Take a look at my Youtube Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/RolandAjeti"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Take a look at my Twitter Profile"
                  >
                    <FontAwesomeIcon icon={["fab", "twitter"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://rolandajeti-portfolio-website.netlify.app/"
                    aria-label="Take a look at my Portfolio Website"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faBriefcase} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*-----------End of Footer----------- */}
    </>
  );
};

export default Home;
